import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import "@/App.css";

// Public Pages
import HomePage from "./pages/HomePage";
import PackagesPage from "./pages/PackagesPage";
import MediaPage from "./pages/MediaPage";
import FAQsPage from "./pages/FAQsPage";
import ReviewsPage from "./pages/ReviewsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AvailabilityPage from "./pages/AvailabilityPage";
import ClientLoginPage from "./pages/ClientLoginPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminPackages from "./pages/admin/AdminPackages";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminAbout from "./pages/admin/AdminAbout";
import AdminWidgets from "./pages/admin/AdminWidgets";
import AdminSettings from "./pages/admin/AdminSettings";

// Components
import { Toaster } from "./components/ui/sonner";
import SEOHead from "./components/SEOHead";

// Hooks
import { usePageTracking } from "./hooks/usePageTracking";

// API
import { getSettings } from "./lib/api";

const AppRoutes = () => {
  const [settings, setSettings] = useState(null);
  usePageTracking();
  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await getSettings();
        setSettings(res.data);
      } catch (error) {
        console.error('Failed to fetch settings for SEO:', error);
      }
    };
    fetchSettings();
  }, []);
  
  return (
    <>
      <SEOHead settings={settings} />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/packages" element={<PackagesPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/availability" element={<AvailabilityPage />} />
        <Route path="/client-login" element={<ClientLoginPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/packages" element={<AdminPackages />} />
        <Route path="/admin/media" element={<AdminMedia />} />
        <Route path="/admin/faqs" element={<AdminFAQs />} />
        <Route path="/admin/reviews" element={<AdminReviews />} />
        <Route path="/admin/about" element={<AdminAbout />} />
        <Route path="/admin/widgets" element={<AdminWidgets />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
